import { Injectable } from "@angular/core";
import clevertap from "clevertap-web-sdk";
import { PartnerService } from "./partner.service";
import { ActivatedRoute } from "@angular/router";
import { INSURER_FULL_NAME } from "../constants/common.info";

@Injectable({
    providedIn: "root",
})
export class CleverTapService {
  private partnerCode: string;
  private language: string;

  constructor(
    private partnerService: PartnerService,
    private activatedRoute: ActivatedRoute
  ) {
    // Get partner code
    this.partnerCode = this.partnerService.getPartnerCode();

    // Get Language
    let snapshotParam = this.activatedRoute.snapshot.queryParams;

    if (snapshotParam.lang)
      this.language = snapshotParam.lang;
    else
      this.language = "bm";
  }

  // #region User Properties

  updateUserProperties(vehicleValue: any, custValue: any) {
    const identityNo = 
      vehicleValue.psIdentityNo == null 
        ? "NA" 
        : vehicleValue.psIdentityNo;

    const partnerCode =
      this.partnerCode == null || this.partnerCode.trim().toUpperCase() == "PS"
        ? "D2C"
        : this.partnerCode.charAt(0).toUpperCase() +
          this.partnerCode.slice(1).toLowerCase();

    const identity =
      identityNo +
      "_" +
      "Car" +
      "_" +
      partnerCode +
      "_" +
      vehicleValue.carPlate +
      "_" +
      vehicleValue.mobileNo.replace("+", "");

    clevertap.onUserLogin.push({
      Site: {
        // Settings
        "MSG-email": true, // Disable email notifications
        "MSG-push": true, // Enable push notifications
        "MSG-whatsapp": true, // Enable WhatsApp notifications

        // User Info
        "Identity": identity,
        "CT_PS_ID": identity,        
        "Email": vehicleValue.email,
        "Name": vehicleValue.name,
        "Phone": vehicleValue.mobileNo,        
        "Gender": vehicleValue.gender,
        "IdentityNo": vehicleValue.psIdentityNo,
        "Marital Status": custValue.maritalStatus,
        "Preferred Channel": custValue.contactMethod,
        "Postcode": vehicleValue.psPostCode,
        "Vehicle No": vehicleValue.carPlate,
        "Language": this.language.toUpperCase(),
        "EhailingUsed": custValue.eHailingUsed,
        "Type of Insurance": vehicleValue.insuranceType,
        "Partner Name": partnerCode
      }
    });
  }

  // #endregion


  // #region Event Properties

  pageViewed(pageIndex: number){
    let currentPage = "";

    switch (pageIndex) {
      case 0:
        currentPage = "Insurers";
        break;

      case 1:
        currentPage = "Add-on";
        break;

      case 2:
        currentPage = "Personal details";
        break;

      case 3:
        currentPage = "Order summary";
        break;
      default:
        break;
    }

    clevertap.event.push("Page Viewed", {
      "URL": window.location.href,
      "Page Name": currentPage
    });

    if (pageIndex == 1) {
      clevertap.event.push("Quote Generated", {
        "Quote Url": window.location.href,
      });
    }
  }

  insurerSelected(quotationCode: string) {
    clevertap.event.push("Insurer Selected", {
      "Insurer Name": INSURER_FULL_NAME[quotationCode]
    });
  }

  addOnSelected(addOnCode: string) {
    clevertap.event.push("Add-on Selected", {
      "Add-on Name": addOnCode
    });
  }

  motorMembershipSelected(addOnCode: string) {
    clevertap.event.push("Motor Membership Selected", {
      "Motor Membership Name": addOnCode
    });
  }

  personalDetailsFilled(city: string, state: string) {
    clevertap.event.push("Personal Details Filled", {
      "City": city,
      "State": state
    });
  }

  excessFeeSelected(excessName: string) {
    clevertap.event.push("Excess Fee Selected", {
      "Excess Type": excessName
    });
  }

  promoCodeApplied(name: any) {
    clevertap.event.push("Promo Code Applied", {
      "Promo Code Name": name
    });
  }

  referralCodeApplied(referralCode: string) {
    clevertap.event.push("Referral Code Applied", {
      "Referral Code": referralCode
    });
  }

  paymentOptionSelected(paymentType: any, bank: any, installmentMonth: any) {
    clevertap.event.push("Payment Option Selected", {
      "Payment Option Type": paymentType,
      "Bank Name": bank,
      "Monthly Option": installmentMonth
    });
  }

  paymentInitiated() {
    clevertap.event.push("Payment Initiated");
  }

  // #endregion
}
